

export default {
    GET_EXAM_DETAILED:'scoresReportsController/getExamDetail',
    GET_TRANSLATIONS : 'publicTranslationController/getTranslations',
    ON_TRANSLATION_UPDATE :'ON_TRANSLATION_UPDATE',
    AUTHENTICATE:'loginController/attemptLogIn',
    GET_USER_ACCOUNTS:'userDataController/get/users/accounts',
    ON_AUTHENTICATE:'ON_AUTHENTICATE',
    ON_ACCOUNTS_FETCH:'ON_ACCOUNTS_FETCH',
    TEST_STUDENT_IMPORT:"importerController/test",
    GET_CLASS:"classController/get",
    ON_CLASS_FETCH:"ON_CLASS_FETCH",
    GET_IS_REGISTERED:"userDataController/get/admin/registered",
    IS_ACCOUNT_REGISTERED:"IS_ACCOUNT_REGISTERED",
    GET_MY_CLASSES:'classController/getViewableClasses',
    ON_MY_CLASSES_FETCH:'ON_MY_CLASSES_FETCH',
    GET_LICENCE:'licenceController/get',
    GET_BRAINTREE_CODE:'licenceController/get/authentication/code',
    MAKE_PAYMENT:'subscriptionController/make',
    ON_GOT_LICENCE:'ON_GOT_LICENCE',
    GOT_BRAINTREE_CODE:'GOT_BRAINTREE_CODE',
    INSERT_STUDENT_IMPORT:"importerController/import",
    GET_CLASSES_LIST:"classController/get/list",
    GET_CLASS_DATA:"classController/getClassData",
    GET_PRODUCT_FEATURES:"productFeaturesController/getProductFeatures",
    GET_CURRICULUM_DATA:"packageController/getCurriculumData",
    UPDATE_ACCOUNT:"accountController/update",
    UPDATE_APPSTORE:"appStoreController/update",
    GET_COUNTRIES:"internationalizationController/get/countries",
    GET_PERSONAL_INFROMATION:"userDataController/getInformation",
    UPDATE_PERSONAL_INFROMATION:"userDataController/updatePersonal",
    GET_DOES_EMAIL_EXIST:"staffController/isEmailAvalible",
    GET_ACCOUNT:"accountController/get",
    UPDATE_PERSONAL_PASSWORD:"userDataController/updatePassword",
    VALIDATE_CLASS_NAME_CALL : '/classController/verifyClassName',
    EXISITNG_ACCOUNT_STUDENTS: '/classController/doesStudentsExist',
    GET_LANGUAGES: '/packageController/getCurriculumLanguages',
    GET_CLASS_PROGRESS:"progressReportClassController/get",
    GET_CLASS_VOCABULARY_COMPLETED:"progressReportClassController/getVocabularyCompleted",
    GET_CLASS_STUDENT_VOCABULARY_COMPLETED:"progressReportClassController/getVocabularyCompletedStudent",
    GET_CLASS_STUDENT_MYCONTENT_COMPLETED:"progressReportClassController/getMyContentCompletedStudent",
    GET_CLASS_STUDENT_VERB_COMPLETED:"progressReportClassController/getVerbsCompletedStudent",
    GET_CLASS_STUDENT_SENTENCE_COMPLETED:"progressReportClassController/getSentenceCompletedStudent",
    GET_CLASS_STUDENT_GRAMMAR_COMPLETED:"progressReportClassController/getSentenceCompletedStudent?",
    GET_CLASS_STUDENT_EXAM_COMPLETED:"progressReportClassController/getExamCompletedStudent",
    GET_CLASS_EXAM_COMPLETED:"progressReportClassController/getExamCompleted",
    GET_CLASS_EXAM_QUESTION:"progressReportClassController/getExamQuestion",
    GET_CLASS_PRONUNCIATION_COMPLETED:"progressReportClassController/getPronunciationCompleted",
    GET_CLASS_GRAMMER_COMPLETED:"progressReportClassController/getGammerCompleted",
    GET_CLASS_SENTENCE_COMPLETED:"fakeController/getSentenceCompleted",
    GET_CLASS_VERB_COMPLETED:"progressReportClassController/getVerbCompleted",
    SET_NICKNAME:'studentsController/setNickname',
    GET_STUDENT_PROGRESS:"progressReportStudentController/get",
    GET_STUDENT_VOCABULARY_COMPLETED:"progressReportStudentController/getVocabularyCompleted",
    GET_STUDENT_EXAM_COMPLETED:"progressReportStudentController/getExamCompleted",
    GET_STUDENT_PRONUNCIATION_COMPLETED:"progressReportStudentController/getPronunciationCompleted",
    GET_STUDENT_GRAMMER_COMPLETED:"progressReportStudentController/getGammerCompleted",
    GET_MODULE_TRANSLATIONS:"admintranslationController/getModules",
    GET_CLASS_ACTIVITY:'recentActivity/getAllClassActivity',
    GET_STUDENT_ACTIVITY:'recentActivity/getAllStudentActivity',
    GET_STUDENTS:'statisticsController/getStudentList',
    GET_TEACHERS: 'statisticsController/getTeacherList',
    GET_VOCAB_TRANSLATIONS:"vocabTranslationController/getVocabTranslations",
    GET_ALL_MODULE_IDS:"screensController/getAllModuleIds",
    GET_ALL_VOCAB_GAMES:"gamesController/getGamesAll",
    GET_ALL_SENTENCEBUILDING_IDS:"screensController/getAllSentenceBuildingModules",
    GET_CLASSES_HIGHSCORE:"highscoreController/classes",
    GET_CLASSES_STUDENTS_HIGHSCORE:"highscoreController/studentsClass",
    GET_ACCOUNT_STUDENTS_HIGHSCORE:"highscoreController/studentsAccount",
    GET_CLASS_LANGUAGE_COURSE:'/scoresReportsController/getLanguageCourseCompleted',
    GET_ALL_GRAMMAR_IDS:"screensController/getAllGrammarModules",
    GET_ALL_GRAMMAR_GAMES: "",
    GET_ALL_VERB_IDS:"verbTranslationController/getAllVerbs",
    GET_ALL_SENTENCE_GAMES:"gamesController/getGamesAll",
    GET_SENTENCE_TRANSLATIONS:"sentenceTranslationController/getSentenceTranslations",
    GET_VERB_TRANSLATIONS:"verbTranslationController/getVerbTranslations",
    GET_EXAM_TRANSLATIONS:"examTranslationController/getExamTranslationsTotal",
    GET_ALL_VERB_GAMES:"verbTranslationController/getVerbGames",
    ADD_NEW_ASSIGNMENT:"assignmentController/completeAddAssignment",
    EDIT_ASSIGNMENT:"assignmentController/completeEditAssignment",
    DUPLCATE_ASSIGNMENT:"assignmentController/duplicateHomeworkAssign",
    DUPLCATE_LIBRARY_ASSIGNMENT:"assignmentController/duplicateLibraryHomeworkAssign",
    GET_EXAM_COURSE:'scoresReportsController/getExamCompleted',
    GET_SENTENCE_COURSE:'scoresReportsController/getSentenceCourseCompleted',
    GET_VERBS_COURSE:'scoresReportsController/getVerbCourseCompleted',
    GET_GRAMMAR_COURSE :'/scoresReportsController/getGrammarCourseCompleted',
    GET_CLASS_ASSIGNMENTS:'assignmentController/getClasses',
    GET_STUDENT_ASSIGNMENTS:'assignmentController/getViewableStudent',
    GET_CLASS_ARCHIVED_ASSIGNMENTS:'assignmentController/getArchivedClasses',
    GET_MY_ASSIGNMENTS:'assignmentController/getViewable',
    GET_MY_ARCHIVED_ASSIGNMENTS:'assignmentController/getArchivedHomework',
    GET_ACCOUNT_STAFF:'staffController/getAccountsStaff',
    GET_ACCOUNT_STUDENTS:'accountController/getStudents',
    GET_CLASS_LANGUAGE_COURSE_DETAIL:'scoresReportsController/getLanguageCourseDetail',
    GET_HOMEWORKS_FEATURES: '/assignmentController/getHomeworksFeatures',
    GET_USERS_COMPLETED: '/assignmentScoresController/getUsersCompleted',
    GET_SCORES: '/assignmentScoresController/get',
    DELETE_CLASS: 'classController/deleteClass',
    DELETE_STUDENT: 'classController/deleteStudent',
    UPDATE_CLASS_NAME:'classController/changeName',
    UPDATE_STUDENT_NAME:'classController/changeStudentName',
    UPDATE_STUDENT_LANGUAGE:'classController/changeStudentDefaultLanguage',
    UPDATE_STUDENT_CLASSES:'classController/changeStudentClasses',
    GET_CLASSES_LANGUAGES:'classController/updateClassLanguages',
    UPDATE_CLASS_HINTS:'classController/toggleHints',
    SET_DELETED:'/assignmentController/deleteHomework',
    SET_ARCHIVED:'/assignmentController/setArchive',
    GET_BUILDING_DETAILED:'/scoresReportsController/getSentenceBuildingDetailed',
    CREATE_CLASS:'/classController/createClass',
    ADD_STUDENTS:'/classController/addStudents',
    DOES_STUDENT_EXIST:'classController/doesStudentsExist',
    GET_EXAM_PROPER:'learningOutcomesController/getExamProper',
    GET_GRADABLE_QUESTIONS:'assignmentController/getGradableQuestions',
    GET_GRADED_QUESTIONS_INDIVIDUAL:'assignmentController/getGradableQuestionIndividual',
    GET_GRADED_QUESTIONS:'assignmentController/getGradedQuestions',
    GET_EXAM_DATA:'examTranslationController/getExamDataTranslations',
    ADD_NEW_FEEDBACK :  '/assignmentController/addNewFeedback',
    GET_VERBS_DETAILED:'/scoresReportsController/getVerbsDetailView',
    MAKE_STAFF_MEMBER:'staffController/createStaffMember',
    GET_TEACHERS_SCREEN:'screensController/getTeacherScreen',
    GET_CUSTOM_MODULE_IDS:'screensController/getModuleIds',
    CUSTOM_MODULES:'contentCreationController/fetchModulesLanguage',
    RQUEST_RENEW:'mailControllerPrivate/sendRenewal',
    SEND_MSG:'mailControllerPrivate/sendMessage',
    GET_ACCOUNT:'accountController/getInformation',
    REMOVE_STUDENT:'classController/removeUser',
    SCORE_SUMMARY:'scoreSummaryController/getSummary',
    GET_EXAM_CATALOG:'examTranslationController/getExamTranslations',
    UPDATE_CLASS_STAFF:'classController/updateStaff',
    UPDATE_CLASS_STUDENTS:'classController/updateStudents',
    GET_CLASS_FAV_ASSIGNMENTS:'assignmentController/getClassFav',
    GET_FAV_ASSIGNMENTS:'assignmentController/getFav',
    UPDATE_FAV:'assignmentController/addFavourite',
    UPDATE_FAV_LIBRARY:'assignmentController/addFavouriteLibrary',
    GET_ALL_FAV:'assignmentController/getFav',
    GET_ADDITIONAL_CURRICULUM: 'packageController/getAdditionalCurriculums',
    GET_SHARED_CURRICULUM:'packageController/getSharedLibrary',
    SET_ADDITIONAL_CURRICULUM: 'packageController/setAdditionalCurriculums',
    GET_USER_DATA: 'userDataController/getUserData',
    ALL_SONG_AND_STORIES_UPDATE:'/SongsAndStories/getAll',
    GET_SCREEN_MODULES: '/screensController/getAllModuleIds',
    GET_CATALOG_VOCAB:'/vocabTranslationController/getCatalogsVocabTranslations',
    ALL_LESSONS:'/LessonPlans/getAll',
    VOCABULARY_SEARCH:'/searchController/HomeworkVocabSearch',
    MAKE_CONTENT :  'contentCreationController/makeModule',
    FETCH_CONTENT : 'contentCreationController/fetchModules',
    FETCH_CONTENT_LANGAUGE: 'contentCreationController/fetchModulesLanguage',
    GET_CATALOG_SUMMARY:  'contentCreationController/fetchModuleSummary',
    ADD_VOCAB:'contentCreationController/addVocabItem',
    REMOVE_VOCAB: 'contentCreationController/removeVocabItem',
    ON_MY_CONTENT_UPDATE : 'ON_MY_CONTENT_UPDATE',
    GET_CATALOG_VOCAB: '/vocabTranslationController/getCatalogsVocabTranslations',
    ON_VOCAB_FETCH :  'ON_VOCAB_FETCH',
    ON_SUMMARY_FETCH :'ON_SUMMARY_FETCH',
    UPLOAD_AUDIO :'contentCreationController/uploadAudio',
    MAKE_VOCAB : 'contentCreationController/makeVocab',
    PUBLISH : 'contentCreationController/setPublished',
    UN_PUBLISH :'contentCreationController/setUnpublished',
    DELETED_CUSTOM :'contentCreationController/setDeleted',
    ON_VERBS_FETCH : 'ON_VERBS_FETCH',
    VERBS_FETCH : 'verbTranslationController/getVerbTranslations',
    SENTENCE_FETCH:'sentenceTranslationController/getSentenceTranslations',
    ON_SENTENCE_FETCH:'ON_SENTENCE_FETCH',
    GET_EXAM_LEARNING:'learningOutcomesController/getExam',
    DELETE_CONTENT:'contentCreationController/deleteContent',
    GET_CATALOG_UID:'screensController/getCatalogUid',
    CUSTOM_VOCABULARY_MODULE_SUMMARY:'contentCreationController/fetchModuleSummary',
    EDIT_CONTENT:'contentCreationController/edit',
    GET_ASSIGNMENT_LIBRARY: 'assignmentController/getAssignmentLibrary',
    GET_LIBRARY_SINGLE: 'assignmentController/getAssignmentLibrarySingle',
    EDIT_ACCOUNT_STAFF: 'staffController/editStaffMember',
    EDIT_ACCOUNT_STAFF_PASSWORD:'staffController/editPassword'
}
